// removed by extract-text-webpack-plugin
module.exports = {"buyers-premium":"buyers-premium___3Y9Vb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BuyersPremium/BuyersPremium.scss
// module id = ij/i
// module chunks = 46